import React, { useState } from "react";
import "./Categories.css";

// ✅ Import all category images from local assets
import interiorImg from "../assets/categories/interior.jpg";
import exteriorImg from "../assets/categories/exterior.jpg";
import chalkImg from "../assets/categories/chalk.jpg";
import glossImg from "../assets/categories/gloss.jpg";
import matteImg from "../assets/categories/matte.jpg";
import texturedImg from "../assets/categories/textured.jpg";
import ecoImg from "../assets/categories/eco.jpg";

const Categories = () => {
  const categories = [
    {
      name: "Interior Paint",
      img: interiorImg,
      desc: "Interior paints are designed to provide a smooth and even finish for your indoor spaces. They offer a variety of finishes, from matte to gloss, and come in a wide range of colors to suit every home’s style. Interior paints are formulated to resist stains, moisture, and fading, making them perfect for high-traffic areas.",
    },
    {
      name: "Exterior Paint",
      img: exteriorImg,
      desc: "Exterior paints are engineered to deliver long-lasting protection and beauty for your home’s outer surfaces. Built to endure extreme weather conditions, they form a strong, weather-resistant coating that shields walls from rain, sunlight, and humidity. These paints not only preserve your building’s exterior but also enhance its overall appearance with rich color and durable finishes.",
    },
    {
      name: "Chalk Paint",
      img: chalkImg,
      desc: "Chalk paint offers a soft, ultra-matte finish that brings a timeless and elegant look to any space. Perfect for furniture, cabinets, and accent pieces, it creates a charming vintage or shabby-chic appearance. With minimal surface preparation required, this paint can be applied directly to wood, metal, or previously painted surfaces, making it a favorite among DIY enthusiasts and interior decorators.",
    },
    {
      name: "Gloss Paint",
      img: glossImg,
      desc: "Gloss paint provides a sleek, shiny finish that adds a touch of elegance and sophistication to any surface. Known for its excellent durability and smooth reflective appearance, it’s ideal for doors, trims, and furniture. This paint resists dirt, stains, and moisture, ensuring long-lasting brightness and easy maintenance — making it a smart choice for both interior and exterior use.",
    },
    {
      name: "Matte Paint",
      img: matteImg,
      desc: "Matte paint delivers a smooth, non-reflective finish that brings warmth and elegance to your interiors. Perfect for living rooms, bedrooms, and ceilings, it helps conceal surface imperfections while creating a soft, sophisticated atmosphere. Though less glossy, its velvety texture adds depth and a natural charm that enhances the beauty of any space.",
    },
    {
      name: "Textured Paint",
      img: texturedImg,
      desc: "Textured paint adds depth and character to walls and ceilings, transforming plain surfaces into stunning decorative features. It creates a rich visual effect that can mimic materials like stucco, stone, or fabric, giving your interiors a premium designer look. Ideal for accent walls, textured finishes not only enhance style but also help conceal surface imperfections effectively.",
    },
    {
      name: "Eco-Friendly Paint",
      img: ecoImg,
      desc: "Eco-friendly paint offers a sustainable and safe option for modern homes, combining vibrant colors with low environmental impact. Formulated with low or zero VOCs, these paints ensure cleaner indoor air quality and are ideal for families seeking a healthier living space. They deliver excellent coverage, durability, and a smooth finish — all while being kind to the planet.",
    },
  ];

  const [active, setActive] = useState(categories[0]);
  const [fade, setFade] = useState(false);

  const handleCategoryClick = (cat) => {
    setFade(true);
    setTimeout(() => {
      setActive(cat);
      setFade(false);
    }, 300); // smooth transition delay
  };

  return (
    <section className="categories-section" id="categories">
      <h2 className="section-title">Paint Categories</h2>

      <div className="categories-row">
        {categories.map((cat, index) => (
          <button
            key={index}
            className={`category-btn ${active.name === cat.name ? "active" : ""}`}
            onClick={() => handleCategoryClick(cat)}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className={`category-showcase ${fade ? "fade-out" : "fade-in"}`}>
        <div className="category-left">
          <img src={active.img} alt={active.name} className="category-img" />
        </div>
        <div className="category-right">
          <h3>{active.name}</h3>
          <p>{active.desc}</p>
        </div>
      </div>
    </section>
  );
};

export default Categories;
